import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import MainImage from "../Assets/image 36.png";
import img from "../Assets/image 55.png";
import img2 from "../Assets/Link → trend2.png.png";
import Footer from "../Components/Footer";
import { useParams } from "react-router-dom";
import { Create_Api, Get_Api } from "../Api_Url";
import ContentLoader from "react-content-loader";
import { toast } from "react-toastify";
import GallerySlider from "../Components/GallerySlider";
import { Helmet } from "react-helmet-async";

function DestinationDetail() {
  const { id } = useParams();
  const [Destination, setDestination] = useState({});
  const [IsUploading, setIsUploading] = useState(false);

  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  const GetDestination = async () => {
    try {
      setIsUploading(true);
      // const response = await Get_Api(`api/admin/GetADestination/${id}`);
      const response = await Get_Api(`api/admin/GetADestinationByName/${id}`);
      setDestination(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (id !== null) {
      GetDestination();
    }
  }, [id]);

  const [AllDestination, setAllDestination] = useState([]);

  const GetAllDestination = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllDestination`);
      setAllDestination(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    GetAllDestination();
  }, []);

  const [selectedDestination, setSelectedDestination] = useState("");

  const handleChange = (e) => {
    setSelectedDestination(e.target.value);
  };

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Number, setNumber] = useState("");

  const SendContactUs = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error("Name is required!");
    if (!Email) return toast.error("Email is required!");
    if (!Number) return toast.error("Number is required!");
    try {
      let data = {
        Name,
        Email,
        Number,
        Destination: selectedDestination || id
      };
      setIsUploading(true);
      const response = await Create_Api(
        `api/admin/CreateDestinationForm`,
        data
      );
      toast.success(response?.message);
      setName("");
      setEmail("");
      setNumber("");
      setSelectedDestination("");
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      toast.error(error?.response?.data?.message);
      console.log(error);
    }
  };

  const [activeTab, setactiveTab] = useState("Itinerary");

  const handleTabChange = (data) => {
    setactiveTab(data);
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>{Destination?.Heading || "Destination Details"}</title>
        <meta
          name="description"
          content={
            Destination?.MetaDescription || "Explore destination details"
          }
        />
        {Destination?.MetaTags?.map((tag, index) => (
          <meta key={index} name="keywords" content={tag} />
        ))}
      </Helmet>
      <Navbar />
      {IsUploading ? (
        <ContentLoader
          width={"100%"}
          height={"100%"}
          viewBox="0 0 450 400"
          backgroundColor="#f0f0f0"
          foregroundColor="#dedede"
        >
          <rect x="43" y="304" rx="4" ry="4" width="271" height="9" />
          <rect x="44" y="323" rx="3" ry="3" width="119" height="6" />
          <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
        </ContentLoader>
      ) : (
        <>
          <div
            className="about-div"
            style={{
              backgroundImage: `url(${Destination?.BannerImage || MainImage})`
            }}
          >
            <h1>{Destination?.DestinationName}</h1>
            <p>
              <i>Home - Destination - {Destination?.DestinationName}</i>
            </p>
          </div>
          <div className="havequestion">
            {/* <h1> {Destination?.Heading}</h1> */}
            {Destination?.Heading && (
              <h1>
                {Destination?.Heading?.split(" ")?.slice(0, 4)?.join(" ")}{" "}
                <br />
                {Destination?.Heading?.split(" ")?.slice(4)?.join(" ")}
              </h1>
            )}
          </div>
          <div className="travel">
            <div className="travel-left">
              <img src={Destination?.HeadingImage || img} />
            </div>
            <div className="travel-right">
              <p>{Destination?.Details}</p>
            </div>
          </div>
          <div className="travel">
            <div className="travel-right">
              <h2>ABOUT {Destination?.DestinationName}</h2>
              <p>{Destination?.About}</p>
            </div>
            <div className="travel-left">
              <img src={Destination?.AboutImage || img} />
            </div>
          </div>
          <div className="havequestion">
            <h1>BASIC INFORMATION</h1>
          </div>
          <br />
          <div className="basicinfo-div">
            <div className="basicinfo">
              <div className="basicinfo-info">
                <p>
                  <b>Country</b>
                </p>
                <p>{Destination?.Country?.Name}</p>
              </div>
              <div className="basicinfo-info">
                <p>
                  <b>Currency Used</b>
                </p>
                <p>{Destination?.Currency}</p>
              </div>
              <div className="basicinfo-info">
                <p>
                  <b>Price Starting</b>
                </p>
                <p>Rs. {Destination?.Price}</p>
              </div>
            </div>
          </div>
          <div className="heading-cnter">
            <h3>OUR OFFICES</h3>
          </div>
          <div className="tab-container">
            <div className="tabs">
              <button
                className={
                  activeTab === "Itinerary" ? "tab-btn active" : "tab-btn"
                }
                onClick={() => handleTabChange("Itinerary")}
              >
                Itinerary
              </button>
              <button
                className={activeTab === "QnA" ? "tab-btn active" : "tab-btn"}
                onClick={() => handleTabChange("QnA")}
              >
                QnA
              </button>
              <button
                className={
                  activeTab === "Amenities" ? "tab-btn active" : "tab-btn"
                }
                onClick={() => handleTabChange("Amenities")}
              >
                Amenities
              </button>
            </div>
          </div>
          <div className="tab-content">
            {activeTab === "Itinerary" && (
              <div className="itinerary-container">
                <div className="timeline">
                  {Destination?.Itinerary?.map((item) => (
                    <div
                      className="timeline-item"
                      key={item?._id}
                      onClick={() => toggleItem(item?._id)}
                    >
                      <div className="content">
                        <h3
                          className={`sub-heading ${
                            openItem === item?._id ? "green" : "gray"
                          } `}
                        >
                          Day {item?.heading}{" "}
                          {openItem === item?._id ? "▲" : "▼"}
                        </h3>
                        {openItem === item?._id && <p>{item?.text}</p>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === "QnA" && (
              <div className="faq-div">
                {Destination?.QnA?.map((item, index) => (
                  <div className={`faq-btn ${openIndex === index ? "active" : ""}`} key={index}>
                    <button onClick={() => toggleAccordion(index)}>
                      <span>{item?.Question}</span>
                      <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                        {openIndex === index ? "-" : "+"}
                      </span>
                    </button>
                    {openIndex === index && (
                      <div className="faq-ans">{item?.Ans}</div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {activeTab === "Amenities" && (
              <div className="amenities-container">
                <h3 className="amenities-heading">Amenities</h3>
                <ul className="amenities-list">
                  {Destination?.Amenities?.map((item) => (
                    <li key={item?._id} className="amenity-item">
                      <span className="check-icon">✔</span>
                      {item?.Name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="gallery">
            <div className="gallery-heading">
              <h3>GALLERY</h3>
              <p>
                Some Basic information about {Destination?.DestinationName} that
                can help you a lot when you visit so
                <br /> check out all the information before starting your tour
              </p>
            </div>
            <br />
            {/* <div className='gallery-div-grid'>
              {Destination?.Gallary?.map((image, index) => (
                <img key={index} src={image || img2} alt={`Gallery Image ${index + 1}`} />
              ))}
            </div> */}

            <GallerySlider Destination={Destination} />
          </div>
          <div className="ready-to">
            <div className="ready-to-div">
              <h3>
                <i>Ready to embark</i> on your next adventure?
              </h3>
              <br />
              <label>Name</label>
              <input
                placeholder="Your Name"
                value={Name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
              <br />
              <br />
              <label>Email Address</label>
              <input
                placeholder="Your Email"
                value={Email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <br />
              <br />
              <label>Number</label>
              <input
                placeholder="Your Number"
                value={Number}
                onChange={(e) => {
                  setNumber(e.target.value);
                }}
              />
              <br />
              <br />
              <div>
                <label>Destination</label>
                <select value={selectedDestination} onChange={handleChange}>
                  <option value="" disabled>
                    Select one...
                  </option>
                  {AllDestination.map((dest) => (
                    <option key={dest._id} value={dest._id}>
                      {dest.DestinationName}
                    </option>
                  ))}
                </select>
              </div>
              <br />
              <br />
              <button
                onClick={(e) => {
                  SendContactUs(e);
                }}
              >
                {IsUploading ? "Please Wait" : "Submit"}
              </button>
            </div>
          </div>
        </>
      )}
      <Footer />
    </>
  );
}

export default DestinationDetail;
